import { render, staticRenderFns } from "./AddBuilding.vue?vue&type=template&id=50fecfca&scoped=true&"
import script from "./AddBuilding.vue?vue&type=script&lang=js&"
export * from "./AddBuilding.vue?vue&type=script&lang=js&"
import style0 from "./AddBuilding.vue?vue&type=style&index=0&id=50fecfca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fecfca",
  null
  
)

export default component.exports